module.exports = __webpack_public_path__ + "img/confederate states.d6628d05.jpg";